import HTTPService from "../../services/http";

const URL = "/fcm/save-fcm-token";

const saveFCMToken = (data, showNotification = false) =>
    HTTPService({
        method: "post",
        url: URL,
        data: data,
        showNotification,
    });

export default saveFCMToken;
